/**
 * Translations for the timeline feature area.
 */
const timeline = {
  zh: {
    'timeline.hero.title': '我们的故事',
    'timeline.hero.sub': '从领养第一只宠物开始，每一个里程碑都在这里。',
    'timeline.list.aria': '纪念日列表',
    'timeline.loading': '读取中…',
    'timeline.empty.message': '故事才刚刚开始呢，去答题、做小任务、领养宠物吧！',
    'timeline.error.load': '读取失败',

    'timeline.event.justNow': '刚刚',
    'timeline.event.today': '今天',
    'timeline.event.yesterday': '昨天',
    'timeline.event.minutesAgo': '{n} 分钟前',
    'timeline.event.hoursAgo': '{n} 小时前',
    'timeline.event.daysAgo': '{n} 天前',
    'timeline.event.weeksAgo': '{n} 周前',
    'timeline.event.monthsAgo': '{n} 个月前',
    'timeline.event.yearsAgo': '{n} 年前',
  } as Record<string, string>,
  en: {
    'timeline.hero.title': 'Our Story',
    'timeline.hero.sub': 'Every milestone since you adopted your first pet lives here.',
    'timeline.list.aria': 'Memory list',
    'timeline.loading': 'Loading…',
    'timeline.empty.message': 'Your story is just starting! Try a quiz, do a small task, or adopt a pet.',
    'timeline.error.load': 'Could not load',

    'timeline.event.justNow': 'just now',
    'timeline.event.today': 'today',
    'timeline.event.yesterday': 'yesterday',
    'timeline.event.minutesAgo': '{n} min ago',
    'timeline.event.hoursAgo': '{n} hr ago',
    'timeline.event.daysAgo': '{n} days ago',
    'timeline.event.weeksAgo': '{n} wk ago',
    'timeline.event.monthsAgo': '{n} mo ago',
    'timeline.event.yearsAgo': '{n} yr ago',
  } as Record<string, string>,
};

export default timeline;
